import dayjs from "dayjs";
import { message } from "antd";
import { makeRequest, handleDownloadFile } from "@utils/helpers";
import { downloadReportReq } from "./requests";

const REPORT_CLASS = "App\\Exports\\EmployeeEmployment\\EmployeeFullEmploymentExitReportExport";

export const downloadFullEmploymentExitReport = ({ employmentId, joiningDate, setLoader }) => {
  if (!employmentId) {
    message.error("Employee is required to download full employment & exit report.");
    return;
  }

  message.info("Downloading full employment & exit report... wait a few seconds.");

  const parsedJoiningDate = dayjs(joiningDate);
  const from = parsedJoiningDate.isValid()
    ? parsedJoiningDate.format("YYYY-MM-DD")
    : dayjs().startOf("year").format("YYYY-MM-DD");
  const to = dayjs().format("YYYY-MM-DD");
  const filters = `employee_|${employmentId};from_|${from};to_|${to};`;
  const payload = {
    page: 1,
    filters: `${filters}report_id_|class_name,user|${employmentId};format_|xlsx;class_name_|${REPORT_CLASS}`,
    employment_id: employmentId,
    format: "xlsx",
    class_name: REPORT_CLASS,
  };

  makeRequest(setLoader || (() => {}), downloadReportReq, payload, onDownloadFullEmploymentExitReportSuccess(setLoader), onDownloadFullEmploymentExitReportSuccess(setLoader));
};

const onDownloadFullEmploymentExitReportSuccess = (setLoader) => (err, res) => {
  if (setLoader) {
    setLoader(false);
  }

  const response = res || err;
  if (response?.code === undefined && response?.type) {
    const fileName = `Employee_Full_Employment_Exit_Report_${dayjs().format("YYYY-MM-DD")}.xlsx`;
    handleDownloadFile(fileName, response);
    return;
  }

  message.error(response?.message || response?.response?.data?.message || "Unable to download full employment & exit report.");
};
